/* eslint-disable no-unused-vars */
import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Text,
  Heading,
  Button,
} from "@chakra-ui/react";
import technical from "./technicalData";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import Card1 from "./cardWOImage";
import "./gallery.css";
import "./timeline.css";
import techCoordinatorData from "./techCoordinatorData";

const Timeline = () => {
  return (
    <Box
      align={"center"}
      justify={"center"}
      style={{
        minWidth: "70vw",
        width: "90vw",
        padding: "0px",
      }}
    >
      {/* <Heading textAlign={"center"} padding={"2"} color={"orange.400"}>
        Technical Events
      </Heading> */}
      <Box
        minW={"350px"}
        direction="row"
        wrap="wrap"
        align="center"
        justify="center"
      >
        {techCoordinatorData.map((user, index) => (
          <Card1 user={user} key={index} />
        ))}
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {technical.length > 0 && (
          <Accordion style={{ width: "90%" }}>
            {technical.map((data, index) => {
              return (
                <AccordionItem key={index}>
                  <h2>
                    <AccordionButton
                      _expanded={{ bg: "#DD6B20", color: "white" }}
                    >
                      <Box flex="1" textAlign="left">
                        {data.title}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel>
                    <Text as="samp" fontSize="xs">
                      {data.date}
                    </Text>
                    <div>
                      <ul style={{ textAlign: "left" }}>
                        {data.rules.length !== undefined &&
                          data.rules.map((item, index) => {
                            return (
                              <>
                                {/* <Text as='b' style={{ display: 'inline' }} fontSize='sm'>{index + 1}.</Text> */}
                                <li style={{ display: "inline" }} key={index}>
                                  &nbsp;
                                  <Text
                                    as="i"
                                    style={{ display: "inline" }}
                                    fontSize="sm"
                                    key={index}
                                  >
                                    {item}
                                  </Text>
                                </li>
                                <br />
                              </>
                            );
                          })}
                      </ul>
                    </div>
                  </AccordionPanel>
                </AccordionItem>
              );
            })}
          </Accordion>
        )}
      </Box>
      <br />
      <br />
      <a
        href="https://forms.gle/fA2k3ubXiaav6fNP9"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button colorScheme="blue" rightIcon={<ArrowForwardIcon />} size="lg">
          Register for an Event
        </Button>
      </a>
    </Box>
  );
};

export default Timeline;
